__turbopack_context__.v({
  "borderNone": "VerticalSection-module-scss-module__UCUJjG__borderNone",
  "content": "VerticalSection-module-scss-module__UCUJjG__content",
  "subtitle": "VerticalSection-module-scss-module__UCUJjG__subtitle",
  "title": "VerticalSection-module-scss-module__UCUJjG__title",
  "titleCenter": "VerticalSection-module-scss-module__UCUJjG__titleCenter",
  "titleEnd": "VerticalSection-module-scss-module__UCUJjG__titleEnd",
  "titleStart": "VerticalSection-module-scss-module__UCUJjG__titleStart",
  "topPanel": "VerticalSection-module-scss-module__UCUJjG__topPanel",
  "verticalSection": "VerticalSection-module-scss-module__UCUJjG__verticalSection",
});
